import { logger } from "@sentry/react";

export function createLog(log: string, type: "trace" | "debug" | "info" | "warn" | "error" | "fatal" = "info", data: Record<string, string | boolean | number> = {}) {
    switch (type) {
        case "info":
        case "debug":
        case "warn":
        case "error":
        case "fatal":
        case "trace":
            logger[type](log, data);
            break;
        default:
            throw new Error();
    }
}
